import { useSortable } from '@dnd-kit/react/sortable'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/ui/icon'
import { Switch } from '@/components/ui/switch'
import { Tooltip } from '@/components/ui/tooltip'

import * as S from './block-item.styled'
import { BlockItemLabel } from './block-item-label'

interface SortableBlockItemProps {
  id: string
  index: number
  label: string
  checked: boolean
  disabled?: boolean
  // Can't currently be turned on/reordered (e.g. shortcuts cap reached, or the parent widget is
  // off) - grayed out, drag disabled, switch disabled.
  locked?: boolean
  // Shown on hover of the toggle itself (e.g. explaining why it's disabled) - not the row.
  tooltip?: ReactNode
  onToggle: () => void
}

export const SortableBlockItem = ({
  id,
  index,
  label,
  checked,
  disabled,
  locked,
  tooltip,
  onToggle,
}: SortableBlockItemProps) => {
  const { t } = useTranslation(['home-screen'])
  const { ref } = useSortable({ disabled: locked, id, index })
  const toggle = (
    <Switch checked={checked} disabled={disabled || locked} size="small" onChange={onToggle} />
  )

  return (
    <S.Row ref={ref} $locked={locked}>
      <S.DragHandle $disabled={locked} aria-label={t('home-screen:labels.dragHandleLabel')}>
        <Icon icon={DotsSixVerticalIcon} size="1.6rem" />
      </S.DragHandle>
      <S.Label>
        <BlockItemLabel label={label} />
      </S.Label>
      {tooltip ? <Tooltip trigger={toggle}>{tooltip}</Tooltip> : toggle}
    </S.Row>
  )
}
